// extracted by mini-css-extract-plugin
module.exports = {"link":"icon-link_link__37uwq","icon":"icon-link_icon__1NYE7","iconOnly":"icon-link_iconOnly__1QX2E","notifMarker":"icon-link_notifMarker__3mTc5"};